import * as React from "react";
const SvgChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.95005 8.25L6.00005 4.2L10.05 8.25", stroke: "currentColor", strokeWidth: 1.5 }));
export default SvgChevronUp;
